import { RequestAppointmentInput } from 'src/graphql/__generated__/globalTypes';
import { useGetShopLocationShortName } from './useGetShopLocationShortName';
import { useHotToast } from 'src/utils/useHotToast';
import { useRequestAppointmentMutation } from './__generated__/useRequestAppointment.generated';
import { gql } from '@apollo/client';

export function useRequestAppointment() {
  const toast = useHotToast();
  const locationShortName = useGetShopLocationShortName();
  const [requestAppointment, { data, loading, error }] =
    useRequestAppointmentMutation({
      onError: error => {
        toast.error(error.message);
      },
    });
  const onRequestAppointment = (
    input: Omit<RequestAppointmentInput, 'locationShortName'>,
    cloudflareTurnstileToken: string,
    onSuccess: () => void
  ) => {
    requestAppointment({
      variables: {
        input: {
          ...input,
          locationShortName: locationShortName || '',
        },
        cloudflareTurnstileToken,
      },
      onCompleted: data => {
        if (data.requestAppointment.success) {
          onSuccess();
        } else {
          const errorMessage =
            data.requestAppointment.message ||
            'Failed to create appointment. Please contact the shop directly.';
          toast.error(errorMessage);
        }
      },
    });
  };
  return { onRequestAppointment, data, loading, error };
}

const mutation = gql`
  mutation RequestAppointment(
    $input: RequestAppointmentInput!
    $cloudflareTurnstileToken: String!
  ) {
    requestAppointment(
      input: $input
      cloudflareTurnstileToken: $cloudflareTurnstileToken
    ) {
      success
      message
    }
  }
`;
